import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "section" }
const _hoisted_4 = {
  id: "invisalign-cena",
  style: {"display":"block"}
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "section" }
const _hoisted_7 = {
  id: "invisalign-cena",
  style: {"display":"block"}
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "section" }
const _hoisted_10 = {
  id: "invisalign-cena",
  style: {"display":"block"}
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "section" }
const _hoisted_13 = { id: "invisalign-cena" }
const _hoisted_14 = { class: "text-black" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Lasersko',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.lasersko.title'),
    cover: require('@/assets/covers/lasersko.jpg'),
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_circular_image, {
          class: "laser-urska-katja",
          image: require('@/assets/laser-urska-katja.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.lasersko.p1')
        }, null, 8, _hoisted_2)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('articles.lasersko.kirurgijaTitle')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.lasersko.kirurgijaP')
        }, null, 8, _hoisted_5)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
      _createVNode(_component_a_circular_image, {
        image: require('@/assets/laser-sirolaser-blue.jpg')
      }, null, 8, ["image"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('articles.lasersko.beljenjeTitle')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.lasersko.beljenjeP')
        }, null, 8, _hoisted_8)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('articles.lasersko.parodontTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/laser-urska.jpg'),
          float: "left",
          class: "laser-urska-katja"
        }, null, 8, ["image"]),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.lasersko.parodontP')
        }, null, 8, _hoisted_11)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", _hoisted_13, [
          _createElementVNode("b", _hoisted_14, _toDisplayString(_ctx.$t('articles.lasersko.cenikTitleBold')), 1)
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.lasersko.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'lasersko')))
          }, _toDisplayString(_ctx.$t('articles.lasersko.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.lasersko.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})